// extracted by mini-css-extract-plugin
export var artisan = "style-module--artisan--85b9a";
export var body = "style-module--body--1c869";
export var cover = "style-module--cover--e694e";
export var description = "style-module--description--9a6ea";
export var descriptionSp = "style-module--descriptionSp--9507f";
export var hero = "style-module--hero--22e3a";
export var image = "style-module--image--830d4";
export var label = "style-module--label--0156a";
export var list = "style-module--list--05d63";
export var message = "style-module--message--a8c08";
export var sub = "style-module--sub--8a7db";
export var subTitle = "style-module--subTitle--d3793";
export var text = "style-module--text--f44a5";
export var title = "style-module--title--5fb16";
export var topic = "style-module--topic--255e5";
export var wrapper = "style-module--wrapper--fb019";
export var writer = "style-module--writer--d7493";